import { PROMO_TYPES } from '../global-constants';

export const getPromoDestinationLink = ({ condition, url, sitemap, type }) => {
	let returnedUrl;
	let defaultUrl;

	switch (type) {
		case PROMO_TYPES.EVENT:
		case PROMO_TYPES.PARTS:
		case PROMO_TYPES.SERVICE:
			returnedUrl = url === 'default' ? '' : url;
			break;
		case PROMO_TYPES.VEHICLE:
		case PROMO_TYPES.INCENTIVE:
			// Vehicle promos should always have a url, created by the backend
			// defaultUrl should only be needed for incentive promos

			// For now, this logic is needed for Auto-Gen incentive specials.
			// All these incentives are for new and certified vehicles.
			defaultUrl =
				condition === 'CPO'
					? sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED')
					: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW');

			returnedUrl = !url || url === 'default' ? defaultUrl : url;
			break;
		default:
		// no-op
	}

	return {
		url: returnedUrl
	};
};
